var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "preview-schedule" }, [
      _vm._v("\n    " + _vm._s(_vm.duration) + " HORAS DE LIMPEZA POR\n    "),
      _c("span", [_vm._v(_vm._s(_vm._f("intToCurrency")(_vm.price)))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Produtos de limpeza, transporte e alimentação do profissional inclusos.\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _vm.to_be === "schedule"
      ? _c(
          "div",
          {
            staticClass: "btn bg-pink",
            class: { "btn--loading": _vm.preloader },
            on: { click: _vm.search }
          },
          [_c("span", [_vm._v("buscar")])]
        )
      : _c(
          "div",
          {
            staticClass: "btn",
            class: {
              "bg-pink": !_vm.price_confirmed,
              "bg-pink-outline": _vm.price_confirmed
            },
            on: { click: _vm.confirm }
          },
          [
            !_vm.price_confirmed
              ? _c("span", [_vm._v("confirmar")])
              : _c("span", [_vm._v("confirmado")])
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c79ca8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c79ca8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/ConfirmPeriodAndPrice.vue
// module id = null
// module chunks = 